export const hashLinkId = 'documentation-incidence';
